import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import addNewBook from "../../redux/books/thunk/addBook";
import update from "../../redux/books/thunk/updateBook";

const Form = () => {
  const { book } = useSelector((state) => state.books);
  const dispatch = useDispatch();
  const [state, setState] = React.useState({
    name: "",
    author: "",
    thumbnail: "",
    price: "",
    rating: "",
    featured: false,
  });
  const onSubmit = (e) => {
    e.preventDefault();
    console.log(state);
    if (book) {
      dispatch(update(state));
    } else {
      dispatch(addNewBook(state))
    }
    setState({
      name: "",
      author: "",
      thumbnail: "",
      price: "",
      rating: "",
      featured: false,
    });
  };

  useEffect(() => {
    if (book) {
      setState(book);
    }
  }, [book]);
  return (
    <div className="p-4 overflow-hidden bg-white shadow-cardShadow rounded-md">
      <h4 className="mb-8 text-xl font-bold text-center">Add New Book</h4>
      <form className="book-form" onSubmit={onSubmit}>
        <div className="space-y-2">
          <label htmlFor="name">Book Name</label>
          <input
            required
            className="text-input"
            type="text"
            id="input-Bookname"
            name="name"
            value={state.name}
            onChange={(e) => {
              setState({ ...state, name: e.target.value });
            }}
          />
        </div>
        <div className="space-y-2">
          <label htmlFor="category">Author</label>
          <input
            required
            className="text-input"
            type="text"
            id="input-Bookauthor"
            name="author"
            value={state.author}
            onChange={(e) => {
              setState({ ...state, author: e.target.value });
            }}
          />
        </div>
        <div className="space-y-2">
          <label htmlFor="image">Image Url</label>
          <input
            required
            className="text-input"
            type="text"
            id="input-Bookthumbnail"
            name="thumbnail"
            value={state.thumbnail}
            onChange={(e) => {
              setState({ ...state, thumbnail: e.target.value });
            }}
          />
        </div>
        <div className="grid grid-cols-2 gap-8 pb-4">
          <div className="space-y-2">
            <label htmlFor="price">Price</label>
            <input
              required
              className="text-input"
              type="number"
              id="input-Bookprice"
              name="price"
              min={0}
              value={state.price}
              onChange={(e) => {
                setState({ ...state, price: parseInt(e.target.value) });
              }}
            />
          </div>
          <div className="space-y-2">
            <label htmlFor="quantity">Rating</label>
            <input
              required
              className="text-input"
              type="number"
              id="input-Bookrating"
              name="rating"
              min={1}
              max={5}
              value={state.rating}
              onChange={(e) => {
                setState({ ...state, rating: parseInt(e.target.value) });
              }}
            />
          </div>
        </div>
        <div className="flex items-center">
          <input
            id="input-Bookfeatured"
            type="checkbox"
            name="featured"
            className="w-4 h-4"
            checked={state.featured}
            onChange={(e) => {
              setState({ ...state, featured: e.target.checked });
            }}
          />
          <label htmlFor="featured" className="ml-2 text-sm">
            This is a featured book
          </label>
        </div>
        <button type="submit" className="submit" id="submit">
          {book ? "Update Book" : "Add Book"}
        </button>
      </form>
    </div>
  );
};

export default Form;
